import { render } from "./index_upgrade3.vue?vue&type=template&id=4ddc2a4c&scoped=true"
import script from "./index_upgrade3.vue?vue&type=script&lang=js"
export * from "./index_upgrade3.vue?vue&type=script&lang=js"

import "./index_upgrade3.vue?vue&type=style&index=0&id=4ddc2a4c&lang=scss&scoped=scoped"
import "./index_upgrade3.vue?vue&type=style&index=1&id=4ddc2a4c&lang=scss"
import "./index_upgrade3.vue?vue&type=style&index=2&id=4ddc2a4c&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddc2a4c"]])

export default __exports__